import Vue from 'vue'
import Vuex from 'vuex'
import system from './modules/system.js'
import createPersistedState from "vuex-persistedstate"
import design from './modules/design.js'
import micro from './modules/micro.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    system,
    design,
    micro
  },
  plugins: [createPersistedState(
    {
      storage: window.sessionStorage
    }
  )]
})



// WEBPACK FOOTER //
// ./src/store/index.js